const indexItems = [
  { id: 1, title: '明星塌房', icon: 'ri-emotion-sad-line', count: '328篇', desc: '明星艺人负面事件全记录' },
  { id: 2, title: '网红翻车', icon: 'ri-live-line', count: '256篇', desc: '网红主播直播事故与争议' },
  { id: 3, title: '选秀内幕', icon: 'ri-mic-line', count: '189篇', desc: '选秀节目幕后真相揭秘' },
  { id: 4, title: '品牌风波', icon: 'ri-building-line', count: '145篇', desc: '品牌代言与商业纠纷' },
  { id: 5, title: '社交热议', icon: 'ri-chat-smile-2-line', count: '412篇', desc: '社交平台热点话题追踪' },
  { id: 6, title: '直播事故', icon: 'ri-alert-line', count: '178篇', desc: '直播中的意外与翻车现场' },
  { id: 7, title: '粉丝大战', icon: 'ri-sword-line', count: '203篇', desc: '饭圈粉丝间的激烈交锋' },
  { id: 8, title: '二次元圈', icon: 'ri-ghost-line', count: '134篇', desc: '二次元圈层争议与趣闻' },
  { id: 9, title: '行业爆料', icon: 'ri-file-text-line', count: '167篇', desc: '娱乐行业内部消息披露' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          内容索引<i className="ri-menu-search-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">按专题浏览你感兴趣的内容</p>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#"
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 cursor-pointer hover:border-primary-200/50 transition-colors"
            >
              <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">{item.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
              <div className="mt-2 text-xs font-medium text-primary-500">{item.count}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}